import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
// import auth from './auth';
import env from "./env";

export default class Messagingv2Service {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.PubNub = null;
    this.unsortedChannelList = [];
    this.matchCounter = 0;
    this.nestedChannelList = [];
    this.arrayOfImageUrlsForGallery = [];
    this.$rootScope.paginationMessages = [];
    this.$rootScope.allChannelNames = [];
    this.controlChannelVal = null;
    this.totalAmountOfMissedMessages = 0;
    this.handleLastMessageDataCounter = 0;
    this.currentChannel = null;
    this.isNewChannel = false;
    this.message_data = null;
    this.indexOfArg = null;
    this.$rootScope.allChannelIds = [];
    this.cacheOfSubbedChannels = [];
    this.someOneWasJustHired = false;
    this.channels_in_queue = [];
    this.pause_channel_loading = false;
    this.$rootScope.channels = null;
    this.defaultChannelsSize = 20;
    var _this = this;

    _this.JobblerIsBeingHiredListener = _this.$rootScope.$on("JobblerIsBeingHired", function ($event, params) {
      _this.someOneWasJustHired = true;
    });
    _this.AddChannelToListListener = _this.$rootScope.$on("AddChannelToList", function ($event, params) {
      _this.addThisChannelToOurListOfChannels(params);
    });
    _this.$rootScope.$on("$destroy", _this.JobblerIsBeingHiredListener);
    _this.$rootScope.$on("$destroy", _this.AddChannelToListListener);
  }

  getChannels(max) {
    if (this.$localStorage) {
      var maxparam = 1;
      if (max) {
        maxparam = max;
      }
      let url =
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$localStorage.logged_user.id +
        "/channels?format=json&max=" +
        maxparam +
        "&fields=company.name,channelUser.connected,channelUser.timeToken1,description,event.id,event.isSourcingPost,event.contactInfo.city,event.contactInfo.state,event.contactInfo.streetLine1,event.contactInfo.zipCode,event.name,event.startTime,event.endTime,event.subEvents.deduppedJobbles.shifts.timeInterval,eventId,eventName,eventStartTime,id,isDefault,name";
      var req = {
        method: "GET",
        url: url,
        headers: {
          authorization: "Bearer " + this.$auth.getAccessToken(),
        },
        data: {},
      };
      return this.$http(req);
    }
  }

  getChannelsv1(offsetparam, max) {
    if (this.$localStorage) {
      var maxparam = this.defaultChannelsSize;
      if (max) {
        maxparam = max;
      }
      var url =
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$localStorage.logged_user.id +
        "/listChannels?format=json&companyId=" +
        this.$localStorage.logged_user.company.id +
        "&max=" +
        maxparam +
        "&offset=" +
        offsetparam +
        "&sortBy=dateCreated&order=desc";
      var req = {
        method: "GET",
        url: url,
        headers: {
          authorization: "Bearer " + this.$auth.getAccessToken(),
        },
        data: {},
      };
      return this.$http(req);
    }
  }

  init(channels, is_new_chat_with_jobbler) {
    console.log("we are initiated..");

    var c = null;

    if (is_new_chat_with_jobbler) {
      this.is_new_chat_with_jobbler = true;
    }

    if (channels.channels) {
      c = channels.channels;
    } else {
      c = channels;
    }
    this.subscribeToAllChannels(c);
    this.originalListOfChannels = c;

    console.log("this.originalListOfChannels");
    console.dir(this.originalListOfChannels);

    this.makeUniqueListOfEvents(c);
  }

  initv1(channelsResp, event) {
    var _this = this;

    _this.event = event;

    let resp = {};

    resp.channels = channelsResp.data;

    console.log("initv1");
    console.dir(resp);
    console.dir(_this.event);

    if (resp.channels) {
      if (resp.channels.length > 0) {
        _this.init(resp, _this.PubNub);
      } else {
        _this.$timeout(function () {
          _this.$rootScope.$emit("channelsHaveBeenLoaded", {});
        });
      }
    }
  }

  getChannelTrimmed(id) {
    if (this.$localStorage) {
      var url =
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$localStorage.logged_user.id +
        "/channels/" +
        id +
        "?format=json&conf=web&sort=lastUpdated&max=100&fields=users.id,users.firstName,users.lastName,users.companyPhone,users.username,users.picture1s,users.emailChatNotificationOn,smsChatNotificationOn,users.personalMobilePhone";
      var req = {
        method: "GET",
        url: url,
        headers: {
          authorization: "Bearer " + this.$auth.getAccessToken(),
        },
        data: {},
      };
      return this.$http(req);
    }
  }

  makeUniqueListOfEvents(channels) {
    var _this = this;
    var uniqueEventIdArray = [];
    if (!_this.originalListOfChannels) {
      _this.originalListOfChannels = channels;
    }
    try {
      channels.forEach(function (channel) {
        _this.$rootScope.allChannelNames.push(channel.name);
        _this.$rootScope.allChannelIds.push(channel.id);
        var eventIdObj = {};
        channel.selected = false;
        eventIdObj.channelArrayHolder = [];
        channel.event = {};
        channel.channelUser = {};
        channel.channelUser.timeToken1 = channel.channelUserTt1 ? channel.channelUserTt1 : +new Date(channel.startTime) * 10000;
        channel.channelUser.connected = channel.channelUserConnected;

        eventIdObj.timeZoneId = channel.contactInfo[0].timeZoneId;

        let userTimeZoneName = moment.tz.guess();
        let now = moment.tz(userTimeZoneName);
        let nowThere = moment.tz(eventIdObj.timeZoneId);
        let timeInSeconds = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
        let startTimeAsMoment = moment(channel.startTime);
        let endTimeAsMoment = moment(channel.endTime);

        channel.startTime = startTimeAsMoment.subtract(timeInSeconds, "seconds").format();
        channel.endTime = endTimeAsMoment.subtract(timeInSeconds, "seconds").format();

        channel.event.startTime = channel.startTime;
        channel.event.endTime = channel.endTime;
        channel.event.contactInfo = {};
        if (channel.contactInfo) {
          channel.event.contactInfo.streetLine1 = channel.contactInfo[0].streetLine1;
          channel.event.contactInfo.city = channel.contactInfo[0].city;
          channel.event.contactInfo.state = channel.contactInfo[0].state;
          channel.event.contactInfo.zipCode = channel.contactInfo[0].zipCode;
          channel.event.contactInfo.timeZoneId = channel.contactInfo[0].timeZoneId;
        }
        eventIdObj.eventId = parseInt(channel.eventId, 10);
        channel.event.startTime = channel.startTime;
        channel.event.endTime = channel.endTime;

        /*
                var nowThere = moment.tz(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId);
                var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
                var startTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime);
                var endTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime);
                _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime = startTimeAsMoment.subtract(timeInSec, 'seconds').format();
                _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime = endTimeAsMoment.subtract(timeInSec, 'seconds').format();
                */

        eventIdObj.eventStartTime = channel.startTime;
        eventIdObj.eventLocation =
          channel.event.contactInfo.streetLine1 +
          " " +
          channel.event.contactInfo.city +
          ", " +
          channel.event.contactInfo.state +
          " " +
          channel.event.contactInfo.zipCode;
        eventIdObj.eventName = channel.eventName;
        eventIdObj.isSourcingPost = channel.event.isSourcingPost;
        eventIdObj.timeIntervals = [];
        let timeIntervalsData = {
          startTime: channel.startTime,
          endTime: channel.endTime,
        };
        eventIdObj.timeIntervals.push(timeIntervalsData);
        uniqueEventIdArray.push(eventIdObj);
      });
    } catch (err) {
      console.log("messaging error");
      console.dir(err);
    } finally {
      uniqueEventIdArray = _.uniqBy(uniqueEventIdArray, "eventId");

      var listOfChannels = _this.originalListOfChannels.slice(0);
      _this.nestChannelsWithinEvent(uniqueEventIdArray, listOfChannels);
    }
  }

  nestChannelsWithinEvent(uniqueEventIdArray, originalListOfChannels) {
    var originalListOfChannelsHolder = originalListOfChannels;
    var tempList = originalListOfChannelsHolder;
    var matchCounter = 0;
    var _this = this;
    var validChannels = [];
    var validChannelNames = [];
    var validChannelTokens = [];

    try {
      uniqueEventIdArray.forEach(function (ua) {
        ua.newMessageCounter = 0;
        tempList.forEach(function (channel, i) {
          if (channel.eventId === ua.eventId && channel.channelUser.timeToken1) {
            matchCounter = matchCounter + 1;
            ua.channelArrayHolder.push(channel);
            channel.hasHome = true;
            validChannels.push(channel);
          }
        });
      });
    } finally {
      this.matchCounter = matchCounter;
      this.channelsNestedWithinEvents = uniqueEventIdArray;
    }

    validChannels.forEach(function (channel, x) {
      if (x < 100) {
        validChannelNames.push(channel.name);
        validChannelTokens.push(channel.channelUser.timeToken1);
      }
    });

    _this.PubNub.messageCounts(
      {
        channels: validChannelNames,
        channelTimetokens: validChannelTokens,
      },
      function (status, results) {
        if (results) {
          validChannels.forEach(function (channel) {
            _this.setMissedMessageData(channel, parseInt(results.channels[channel.name], 10));
          });
        } else {
          console.log("error in the result");
        }
      }
    );
  }

  setMissedMessageData(channel, missedMessageCount) {
    var _this = this;
    channel.missedMessagesCount = missedMessageCount;
    if (channel.missedMessagesCount > 0) {
      channel.hasNewMessage = "new-message-highlight-new";
      channel.hasNewMessageContainer = "new-message-highlight-new-container";
      channel.hasNewMessageInbox = "new-message-highlight-new-container-inbox";
      _this.totalAmountOfMissedMessages = _this.totalAmountOfMissedMessages + channel.missedMessagesCount;
    }
    channel.newMessageCounter = channel.missedMessagesCount;
    _this.$timeout(function () {
      _this.getLastMessage(channel);
    });
  }

  getLastMessage(channel, isnew) {
    var _this = this;
    channel.lastMessage = {
      channel: channel.name,
      pubnub: this.PubNub,
      callback: doNext,
    };
    PubNubLib.getLastMessage(channel.lastMessage);

    function doNext(response) {
      channel.lastMessageData = response;
      _this.handleLastMessageData(channel, isnew);
    }
  }

  handleLastMessageData(channel, isnew) {
    var _this = this;

    this.handleLastMessageDataCounter = this.handleLastMessageDataCounter + 1;

    if (!_this.$security.isUndefinedOrNull(channel.lastMessageData)) {
      if (!_this.$security.isUndefinedOrNull(channel.lastMessageData.response)) {
        channel.lastMessageData.response.message = channel.lastMessageData.response.entry;
        channel.lastMessageData.response.timeTokenFormatted = new Date(channel.lastMessageData.response.timetoken / 1e4);
        channel.lastMessageData.response.timeTokenFormattedFull = moment(new Date(channel.lastMessageData.response.timetoken / 1e4)).format();

        var tokenToMoment = moment(channel.lastMessageData.response.timeTokenFormatted);
        var diffBetweenNowAndThen = moment().diff(tokenToMoment, "days");

        if (diffBetweenNowAndThen === 0) {
          channel.lastMessageData.response.timeTokenFormatted = tokenToMoment.format("hh:mm a");
        }

        if (diffBetweenNowAndThen === 1) {
          channel.lastMessageData.response.timeTokenFormatted = "Yesterday";
        }

        if (diffBetweenNowAndThen < 7 && diffBetweenNowAndThen !== 1 && diffBetweenNowAndThen !== 0) {
          channel.lastMessageData.response.timeTokenFormatted = tokenToMoment.format("ddd, hh:mm a");
        }

        if (diffBetweenNowAndThen > 6 && diffBetweenNowAndThen !== 1 && diffBetweenNowAndThen !== 0) {
          channel.lastMessageData.response.timeTokenFormatted = tokenToMoment.format("MMM DD");
        }
      } else {
        channel.lastMessageData.response = {
          message: {
            messagePayload: {
              message: "No messages",
            },
          },
        };
        channel.lastMessageData.response.timeTokenFormatted = "---";
        channel.lastMessageData.response.noMessagesClass = "no-messages-class-inbox";
      }
    }

    if (this.originalListOfChannels) {
      if (this.originalListOfChannels.length === 0) {
        _this.placeNewChannelInList(channel);
      } else {
        var counterOffset = _this.$rootScope.messagesOffsetparam ? _this.$rootScope.messagesOffsetparam : 0;
        if (this.handleLastMessageDataCounter === this.matchCounter + counterOffset) {
          _this.$timeout(function () {
            if (isnew) {
              _this.placeNewChannelInList(channel);
            } else {
              _this.addUpMissedMessages();
            }
          });
        }
      }
    }
  }

  trimEventName(event) {
    if (event.eventName.length > 96) {
      event.eventNameSubStr = event.eventName.substring(0, 96);
      event.eventNameSubStr = event.eventNameSubStr + "...";
    }
  }

  addUpMissedMessages() {
    var _this = this;
    var arrayOfChannelsWithMissedMessages = [];
    var arrayOfChannelsWithoutMissedMessages = [];
    try {
      _this.channelsNestedWithinEvents.forEach(function (ua) {
        ua.show = false;
        _this.trimEventName(ua);
        ua.channelArrayHolder.forEach(function (channel) {
          if (channel.missedMessagesCount > 0) {
            arrayOfChannelsWithMissedMessages.push(ua);
            ua.hasAtleastOneMissedMessage = true;
          }
          ua.newMessageCounter = ua.newMessageCounter + channel.missedMessagesCount;
          if (ua.channelArrayHolder[ua.channelArrayHolder.length - 1] && !ua.hasAtleastOneMissedMessage) {
            ua.hasAtleastOneMissedMessage = false;
            arrayOfChannelsWithoutMissedMessages.push(ua);
          }
        });
      });
    } finally {
      _this.channelsNestedWithinEvents.sort(
        firstBy(function (v1, v2) {
          return v2.newMessageCounter - v1.newMessageCounter;
        })
      );
      _this.$timeout(function () {
        _this.$rootScope.channels = _this.channelsNestedWithinEvents;
        _this.$rootScope.channels.totalMessagesMissed = _this.totalAmountOfMissedMessages;
        _this.$rootScope.channelsHaveLoaded = true;
        _this.$rootScope.$emit("channelsHaveBeenLoaded", {});
      });
    }
  }

  toastMessage(m, channel) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("ToastMessage", {
        m: m,
        channel: channel,
      });
    });
  }

  deleteChannels(arrayOfChannelIdToDelete) {
    var _this = this;
    arrayOfChannelIdToDelete.user = _this.$localStorage.logged_user.id;
    var url = _this.$env.getAPIEndPoint() + "jbl/v1/channels/bulk-delete?format=json&conf=web&verbosity=1";
    var req = {
      method: "POST",
      url: url,
      headers: {
        authorization: "Bearer " + _this.$auth.getAccessToken(),
      },
      data: arrayOfChannelIdToDelete,
    };
    return _this.$http(req);
  }

  createOrReturnChannelTrimmed(users, isGenerate, message_data) {
    if (message_data) {
      this.message_data = message_data;
    }

    if (!users.chat_name) {
      users.allCompanyUsers = true;
    } else {
      users.allCompanyUsers = false;
    }
    if (isGenerate) {
      let arrayObj = {
        event: users.event,
        is_default: true,
      };
      users.events = [];
      users.events.push(arrayObj);
    }
    let url = this.$env.getAPIEndPoint() + "jbl/v1/channels/add-users-to-channel?format=json&conf=web&verbosity=5";
    let req = {
      method: "POST",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: users,
    };
    return this.$http(req);
  }

  handleSubTo(channel, x, issub, isGroupChat) {
    var _this = this;

    if (_this.$rootScope.allChannelNames.indexOf(channel) > -1) {
      console.log("it already exists");
    } else {
      _this.findChannel(channel, x, issub, isGroupChat);
    }
  }

  findChannel(channel, m, issub, isGroupChat) {
    var _this = this;

    if (_this.someOneWasJustHired === true) {
      //_this.someOneWasJustHired=false;
    } else {
      if (_this.$rootScope.allChannelNames) {
        if (_this.$rootScope.allChannelNames.indexOf(channel) > -1) {
          try {
            _this.indexOfArg = _this.$rootScope.allChannelNames.indexOf(channel);
          } finally {
            if (!issub) {
              _this.handleIncomingMessageForExistingChannel(m, issub);
            }
          }
        } else {
          _this.loadChannels(channel, issub, isGroupChat);
        }
      } else {
        _this.loadChannels(channel, issub);
      }
    }
  }

  loadChannels(channel, issub, isGroupChat) {
    var _this = this;

    _this.$timeout(function () {
      if (_this.pause_channel_loading !== true) {
        _this.pause_channel_loading = true;
        _this.getChannels(1).then(
          function (response) {
            if (response.data.channels.length > 0) {
              if (response.data.channels[0].name === channel) {
                let data = {};
                if (_this.$rootScope.allChannelNames.indexOf(channel) === -1) {
                  _this.$rootScope.allChannelNames.push(name);
                }
                data.response = response;
                data.channel = channel;
                data.issub = issub;
                data.isGroupChat = isGroupChat;
                _this.addThisChannelToOurListOfChannels(data);
                if (!issub) {
                  var isnew = true;
                  _this.matchCounter = _this.matchCounter + 1;
                  _this.getLastMessage(response.data.channels[0], isnew);
                  _this.storeTimeTokenForChannel(response.data.channels[0]);
                }

                _this.pause_channel_loading = false;
              } else {
              }
            } else {
            }
          },
          function (error) {
            console.log(error);
          }
        );
      }
    }, 2000);
  }

  initPubnub() {
    var _this = this;

    /*
        _this.PubNub = new PubNub({
            subscribeKey: _this.$env.getPubNubSubKey(),
            publishKey: _this.$env.getPubNubPubKey(),
            uuid: _this.$localStorage.logged_user.id,
            ssl: true,
        });

        _this.PubNub.addListener({
            message: function (message) {
                if (_.has(message.message, "UNSUB-TO")) {
                    let unsubChannel = message["UNSUB-TO"];
                    _this.stripChannelFromGlobalList(message.message, unsubChannel);
                } else {
                    if (_.has(message.message, "SUB-TO")) {
                        let subChannelToAdd = message.message["SUB-TO"];
                        let issub = true;
                        let isGroupChat = false;
                        if (message.message.channelDesc === "Group Chat") {
                            isGroupChat = true;
                        }
                        _this.handleSubTo(subChannelToAdd, null, issub, isGroupChat);
                    } else {
                        if (_this.$rootScope.activeChannel === message.channel) {
                            _this.formatMessageAndPushToChat(message.message, message.channel);
                        } else {
                            if (_this.isNewChannel) {
                                _this.addNewChannelToList(_this.currentChannel, message.message.messagePayload.message);
                                _this.isCurrentUser(message.message.messagePayload, _this.currentChannel);
                            } else {
                                _this.findChannel(message.channel, message.message, false);
                            }
                            if (message.message.messagePayload.userId !== _this.$localStorage.logged_user.id) {
                                _this.toastMessage(message.message, message.channel);
                            }
                        }
                    }
                }
            },
            presence: function (presence) {
                _this.updateUserPresence(presence);
            },
            status: function (status) {
                console.log(status);
            },
        });

        if (_this.$localStorage.logged_user.controlChannel) {
            _this.controlChannelVal = _this.$localStorage.logged_user.controlChannel;
        } else {
            _this.controlChannelVal = _this.$localStorage.logged_user.email.replace(/\./g, "");
        }

        _this.PubNub.channelGroups.addChannels(
            {
                channels: [_this.controlChannelVal],
                channelGroup: _this.controlChannelVal,
            },
            function (status, response) {
                if (status.statusCode === 200) {
                    console.log("subscribe only if status is ok");
                    _this.PubNub.subscribe({
                        channelGroups: [_this.controlChannelVal],
                        withPresence: true,
                        triggerEvents: ["message", "presence", "status"],
                    });
                }
            }
        );
         */
  }

  addThisChannelToOurListOfChannels(info) {
    var _this = this;
  }

  PubNubAddChannelToGroup(channel) {
    var _this = this;
    _this.PubNub.channelGroups.addChannels(
      {
        channelGroup: _this.controlChannelVal,
        channels: [channel],
      },
      function (status, response) {
        console.log("PubNubAddChannelToGroup status, response");
        console.log(status, response);
      }
    );
  }

  addNewChannelToList(channel, message) {
    var _this = this;
    let now = moment().format("hh:mm a");

    _this.PubNub.time().then((time) => {
      let timeTokenVal = time.timetoken;
      channel.lastMessage = {
        callback: doNext,
        channel: channel.name,
        pubnub: _this.PubNub,
      };
      channel.lastMessageData = {
        channel: channel.name,
        error: false,
        response: {
          timeTokenFormatted: now,
          timetoken: timeTokenVal,
          message: {
            messagePayload: {
              message: message,
              userId: _this.$localStorage.logged_user.id,
              username: "Manager",
            },
            pn_apns: null,
            pn_gcm: null,
          },
        },
      };
      channel.hasHome = true;
      channel.missedMessagesCount = 0;
      channel.newMessageCounter = 0;
      channel.selected = false;

      function doNext() {
        _this.handleLastMessageData(channel);
      }

      _this.setMissedMessagesData(channel);
    });
  }

  setMissedMessagesData(channel) {
    var _this = this;
    channel.missedMessagesData = {
      callback: doNext,
      channel: channel.name,
      pubnub: _this.PubNub,
      timeToken: null,
    };

    function doNext(response) {
      _this.setMissedMessageData(channel, response);
    }

    _this.placeNewChannelInList(channel);
  }

  placeNewChannelInList(channel) {
    var _this = this;
    if (!_this.$rootScope.channels) {
      var eventIdObj = {};
      channel.selected = false;
      eventIdObj.channelArrayHolder = [];
      eventIdObj.eventId = parseInt(channel.eventId, 10);
      eventIdObj.eventStartTime = channel.eventStartTime;
      eventIdObj.eventName = channel.eventName;
      eventIdObj.channelArrayHolder.push(channel);
      _this.$timeout(function () {
        _this.$rootScope.allChannelNames = [];
        _this.$rootScope.allChannelNames.push(channel.name);
        _this.$rootScope.channels = [];
        _this.$rootScope.channels.push(eventIdObj);
        _this.$rootScope.channelsHaveLoaded = true;
        _this.$rootScope.$emit("channelsHaveBeenLoaded", {});
      });
    } else {
      var found = false;
      try {
        for (var i = 0; i < _this.$rootScope.channels.length; i++) {
          if (_this.$rootScope.channels[i].eventId === channel.eventId) {
            _this.$rootScope.channels[i].channelArrayHolder.unshift(channel);
            found = true;
            break;
          }
        }
      } finally {
        if (!found) {
          _this.createNewParentEvent(channel);
        }
        _this.isNewChannel = false;
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetChannels", {
            channel: channel.name,
          });
          _this.$rootScope.$emit("StopLoader", {});
        });
      }
    }
  }

  createNewParentEvent(channel) {
    var _this = this;
    var eventIdObj = {};
    channel.selected = false;
    eventIdObj.channelArrayHolder = [];
    eventIdObj.eventId = parseInt(channel.eventId, 10);
    if (channel.eventStartTime) {
      eventIdObj.eventStartTime = channel.eventStartTime;
    } else {
      eventIdObj.eventStartTime = channel.event.startTime;
    }
    if (channel.eventName) {
      eventIdObj.eventName = channel.eventName;
    } else {
      eventIdObj.eventName = channel.event.name;
    }
    if (!channel.eventLocation) {
      eventIdObj.eventLocation =
        channel.event.contactInfo.streetLine1 +
        " " +
        channel.event.contactInfo.city +
        ", " +
        channel.event.contactInfo.state +
        " " +
        channel.event.contactInfo.zipCode;
    }
    if (!eventIdObj.timeIntervals) {
      eventIdObj.timeIntervals = [];
      let timeIntervalsData = {
        startTime: channel.startTime,
        endTime: channel.endTime,
      };
      eventIdObj.timeIntervals.push(timeIntervalsData);
    }
    if (angular.isUndefined(eventIdObj.newMessageCounter)) {
      eventIdObj.newMessageCounter = 0;
    }
    eventIdObj.channelArrayHolder.push(channel);
    _this.$timeout(function () {
      _this.$rootScope.allChannelNames = [];
      _this.$rootScope.allChannelNames.push(channel.name);
      _this.$rootScope.allChannelIds.push(channel.id);
      _this.$rootScope.channels.unshift(eventIdObj);
    });
  }

  publishMessage(
    messageToPublish,
    encodedUrl,
    fileURL,
    userForMessage,
    blocksPayload,
    eventId,
    channel,
    isNewChannel,
    channelNameArg,
    indexOfArg,
    channelId
  ) {
    var _this = this;

    messageToPublish = messageToPublish.trim();

    _this.pause_channel_loading = false;
    var channelName = null;
    var pdfURL = null;

    if (fileURL) {
      if (fileURL.toLowerCase().includes(".pdf?")) {
        pdfURL = fileURL;
      }
    }

    _this.isNewChannel = isNewChannel;
    if (channel) {
      _this.currentChannel = channel;
      channelName = channel.name;
    } else {
      channelName = channelNameArg;
    }
    if (indexOfArg) {
      _this.indexOfArg = indexOfArg;
    }

    var messageHolder = {};
    var messageWrapper = {};

    messageWrapper.username = this.$localStorage.logged_user.firstName + " " + this.$localStorage.logged_user.lastName;
    messageWrapper.message = messageToPublish;
    messageWrapper.eventId = eventId;
    messageWrapper.channelId = channelId;
    messageWrapper.companyName = this.$localStorage.logged_user.company.name;
    messageWrapper.userId = this.$localStorage.logged_user.id;
    messageWrapper.image = encodedUrl;
    messageWrapper.imageURL = pdfURL ? null : fileURL;
    messageWrapper.pdfURL = pdfURL;
    messageWrapper.timetoken = moment().format("hh:mm a");
    messageHolder.message = messageWrapper;

    var formattedMessage = {
      pn_apns: {
        aps: {
          alert: messageToPublish,
          badge: 1,
        },
        source: "pubnub",
      },
      pn_gcm: {
        data: {
          payload: {
            android: {
              title: "Jobble QA Message",
              alert: messageToPublish,
              sound: "default",
              vibrate: true,
            },
            source: "pubnub",
          },
        },
      },
      messagePayload: {
        userId: this.$localStorage.logged_user.id,
        manager: this.$localStorage.logged_user.firstName,
        username: this.$localStorage.logged_user.firstName + " " + this.$localStorage.logged_user.lastName,
        message: messageToPublish,
        channelId: channelId,
        authToken: this.$localStorage.logged_user.access_token,
        eventId: eventId,
        companyName: this.$localStorage.logged_user.company.name,
        image: encodedUrl,
        imageURL: pdfURL ? null : fileURL,
        pdfURL: pdfURL,
      },
      blocksPayload,
    };

    if (encodeURIComponent(channelName + JSON.stringify(formattedMessage)).length + 100 > 32000) {
      alert("unfortunately the message size it too large. Please shorten and send again.");
    } else {
      _this.PubNub.publish(
        {
          channel: channelName,
          message: formattedMessage,
        },
        function (status, response) {}
      );
    }
  }

  generateBlockList(jobblers) {
    var _this = this;
    var recipientsArray = [];
    var blocksPayload = {
      senderUserOrigin: "web",
    };

    try {
      jobblers.forEach(function (jobbler) {
        var recipientsObj = {};
        if (!jobbler.username) {
          jobbler.username = jobbler.email;
        }
        if (!jobbler.personalPhoneMobile && !jobbler.homeContactInfo) {
          jobbler.personalPhoneMobile = jobbler.numberOrig;
        }

        if (jobbler.username !== _this.$localStorage.logged_user.email) {
          recipientsObj.email = jobbler.username;
          recipientsObj.firstName = jobbler.firstName;
          recipientsObj.lastName = jobbler.lastName;
          recipientsObj.userOrigin = "web";
          recipientsObj.emailChatNotificationOn = jobbler.emailChatNotificationOn;
          recipientsObj.smsChatNotificationOn = jobbler.smsChatNotificationOn;
          if (jobbler.personalMobilePhone) {
            recipientsObj.personalMobilePhone = jobbler.personalPhoneMobile;
          }
          if (jobbler.homeContactInfo) {
            recipientsObj.personalMobilePhone = jobbler.homeContactInfo.phoneMobile;
          }
          recipientsObj.companyPhone = jobbler.companyPhone;
          recipientsArray.push(recipientsObj);
        }
      });
    } finally {
      blocksPayload.recipients = recipientsArray;
      return blocksPayload;
    }
  }

  getPubNubTime(channel, findChannelInScopeList) {
    var _this = this;
    if (findChannelInScopeList) {
      var t;
      try {
        for (var i = 0; i < _this.unsortedChannelList.length; i++) {
          if (_this.unsortedChannelList[i].name === channel) {
            t = _this.unsortedChannelList[i];
            break;
          }
        }
      } finally {
        if (t) {
          _this.PubNub.time().then((time) => {
            t.timeTokenOfLastMessageSeenByUser = time.timetoken;
            _this.storeTimeTokenForChannel(t);
          });
        }
      }
    } else {
      _this.PubNub.time().then((time) => {
        channel.timeTokenOfLastMessageSeenByUser = time.timetoken;
        _this.storeTimeTokenForChannel(channel);
      });
    }
  }

  storeTimeTokenForChannel(channel) {
    var _this = this;
    var chArray = [];

    if (channel) {
      _this.PubNub.time().then((time) => {
        channel.timeTokenOfLastMessageSeenByUser = time.timetoken;
        var chObj = {
          ch: channel.id,
          tt1: channel.timeTokenOfLastMessageSeenByUser,
        };
        chArray.push(chObj);
        var channelsAndTimeTokens = {channelsAndTimeTokens: chArray};
        var url = _this.$env.getAPIEndPoint() + "jbl/v1/channels/save-time-tokens?format=json&conf=web";
        var req = {
          method: "POST",
          url: url,
          headers: {
            authorization: "Bearer " + _this.$auth.getAccessToken(),
          },
          data: channelsAndTimeTokens,
        };
        return _this.$http(req).then(function (response) {
          console.log(response);
        });
      });
    }
  }

  handleIncomingMessageForExistingChannel(messagePayload, issub) {
    var _this = this;
    if (!issub) {
      var channel;
      try {
        channel = _this.originalListOfChannels[_this.indexOfArg];
      } finally {
        if (messagePayload.messagePayload.userId === this.$localStorage.logged_user.id) {
          _this.storeTimeTokenForChannel(channel);
        }
        _this.updateLastMessage(channel, messagePayload);
      }
    }
  }

  updateLastMessage(channel, message) {
    var _this = this;
    if (channel) {
      channel.missedMessagesCount = channel.missedMessagesCount + 1;
    }
    if (_this.$rootScope.channels) {
      _this.$rootScope.channels.totalMessagesMissed = _this.$rootScope.channels.totalMessagesMissed + 1;
    }
    if (channel.lastMessageData.response) {
      channel.lastMessageData.response.message.messagePayload = message.messagePayload;
      channel.lastMessageData.response.timetoken = null;
      channel.lastMessageData.response.timeTokenFormatted = moment().format("hh:mm a");
      channel.lastMessageData.response.timeTokenFormattedFull = moment().format();
    }
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetChannels", {
        channel: channel,
      });
    });
  }

  isCurrentUser(message, channel) {
    var _this = this;
    if (message.userId === _this.$localStorage.logged_user.id) {
      _this.storeTimeTokenForChannel(channel);
    }
  }

  updateUserPresence(presence) {
    var _this = this;
    if (presence.channel === _this.$rootScope.activeChannel) {
      _this.$rootScope.$emit("UpdatePresence", {
        channel: presence.channel,
        action: presence.action,
        uuid: presence.uuid,
      });
    }
  }

  getChatHistory(channel, timeToken) {
    var _this = this;
    _this.PubNub.history(
      {
        start: timeToken,
        channel: channel,
        stringifiedTimeToken: true,
        reverse: false,
        count: 100,
      },
      function (status, response) {
        console.log("getChatHistory status response");
        console.log(status, response);

        if (response.messages.length === 0) {
          return;
        }
        _this.$rootScope.paginationMessages = response.messages;
        Array.prototype.push.apply(_this.$rootScope.paginationMessages, _this.$rootScope.activeMessages);
        _this.$rootScope.activeMessages = _this.$rootScope.paginationMessages;

        var startTimeToken = response.startTimeToken;
        if (_this.$rootScope.activeMessages !== "undefined" && _this.$rootScope.activeMessages.length > 0) {
          _this.$rootScope.startToken = startTimeToken;
        }

        try {
          _this.$rootScope.activeMessages.forEach(function (msg) {
            msg.message = msg.entry;
            msg.timetokenFormatted = moment(new Date(msg.timetoken / 1e4)).format("MM/DD/YY hh:mm a");
            if (msg.message.messagePayload.imageURL) {
              _this.arrayOfImageUrlsForGallery.push(msg.message.messagePayload.imageURL);
            }
          });
        } finally {
          _this.$timeout(function () {
            _this.$rootScope.photos = _this.arrayOfImageUrlsForGallery;
          });
        }
      }
    );
  }

  collectJobblersForPresence(jobblers) {
    var _this = this;
    if (jobblers) {
      if (jobblers.length > 0 && !_this.$security.isUndefinedOrNull(jobblers)) {
        try {
          for (var i = 0; i < jobblers.length; i++) {
            var temp = null;
            if (jobblers[i].username) {
              temp = jobblers[i].username.replace(/\./g, "");
            } else {
              temp = jobblers[i].applicant.username.replace(/\./g, "");
            }

            if (_this.$rootScope.arrayOfUniqueOnlineUsers) {
              for (var x = 0; x < _this.$rootScope.arrayOfUniqueOnlineUsers.length; x++) {
                if (_this.$rootScope.arrayOfUniqueOnlineUsers[x].uuid === temp) {
                  jobblers[i].isConnected = true;
                }
              }
            }
          }
        } finally {
          console.log("finally running");
        }
      }
    }
  }

  subtractMissedMessagesFromGlobalBadge(channel, event) {
    var _this = this;
    channel.hasNewMessage = undefined;
    channel.hasNewMessageContainer = undefined;
    channel.hasNewMessageInbox = undefined;

    event.newMessageCounter = event.newMessageCounter - channel.missedMessagesCount;
    channel.newMessageCounter = event.newMessageCounter - channel.missedMessagesCount;
    _this.$rootScope.channels.totalMessagesMissed = _this.$rootScope.channels.totalMessagesMissed - channel.missedMessagesCount;
    channel.missedMessagesCount = 0;
  }

  formatMessageAndPushToChat(message, channel) {
    var _this = this;
    var messagePayload = {};
    messagePayload.username = message.messagePayload.username;
    messagePayload.image = message.messagePayload.image;
    messagePayload.imageURL = message.messagePayload.imageURL;
    messagePayload.pdfURL = message.messagePayload.pdfURL;
    messagePayload.message = message.messagePayload.message;
    messagePayload.userId = message.messagePayload.userId;
    messagePayload.userProfileImage = message.messagePayload.userProfileImage;
    messagePayload.timetoken = moment().format("hh:mm a");
    var messagePayloadTwo = {
      messagePayload,
    };
    var messagePayLoadHolder = {
      message: messagePayloadTwo,
    };

    _this.$timeout(function () {
      try {
        if (_this.$security.isUndefinedOrNull(_this.$rootScope.activeMessages)) {
          _this.$rootScope.activeMessages = [];
          _this.$rootScope.activeMessages.push(messagePayLoadHolder);
        } else {
          _this.$rootScope.activeMessages.push(messagePayLoadHolder);
        }
      } finally {
        if (messagePayLoadHolder.message.messagePayload.imageURL) {
          _this.$rootScope.photos.push(messagePayLoadHolder.message.messagePayload.imageURL);
        }
        _this.$rootScope.$emit("UpdateLastMessage", {
          channel: channel,
          message: messagePayload,
        });
      }
    });
  }

  setHandleLastMessageDataCounter(x) {
    var _this = this;
    _this.handleLastMessageDataCounter = x;
  }

  setTotalAmountOfMissedMessages(x) {
    var _this = this;
    _this.totalAmountOfMissedMessages = x;
  }

  stripChannelFromGlobalList(data, channelName) {
    var _this = this;
    let events = _this.$rootScope.channels;
    let channelToUnsubTo = channelName;
    events.forEach(function (event, index) {
      let channels = event.channelArrayHolder;
      let matchedChannelIndex = channels.findIndex((i) => i.name === channelToUnsubTo);
      if (matchedChannelIndex > -1) {
        _this.stripParentLevelEvent(channels[matchedChannelIndex], events[index]);
        channels.splice(matchedChannelIndex, 1);
      }
    });
  }

  handleChannelSub(channel) {
    var _this = this;
    let channel_array = [];
    channel_array.push(channel);
    console.log("handleChannelSub");
    console.log("handleChannelSub");
    console.log("handleChannelSub");
    console.log("handleChannelSub");

    //_this.subscribeToAllChannels(channel_array);
  }

  subscribeToAllChannels(channels) {
    var _this = this;
    var channelNames = [];
    channels.forEach(function (channel) {
      channelNames.push(channel.name);
    });
    _this.PubNub.channelGroups.addChannels(
      {
        channelGroup: _this.controlChannelVal,
        channels: channelNames,
      },
      function (status, response) {
        console.log("subscribeToAllChannels status, response");
        console.log(status, response);
      }
    );
  }

  stripParentLevelEvent(channel, parentLevelEvent) {
    var _this = this;
    if (parentLevelEvent.channelArrayHolder.length === 1) {
      let eventIdToSplice = parentLevelEvent.id;
      let matchedEventIndex = _this.$rootScope.channels.findIndex((i) => i.id === eventIdToSplice);
      _this.$rootScope.channels.splice(matchedEventIndex, 1);
    }
  }

  getChannel(id) {
    if (this.$localStorage) {
      var url =
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$localStorage.logged_user.id +
        "/channels/" +
        id +
        "?format=json&conf=web&sort=lastUpdated&max=100&connected=true&verbosity=5";
      var req = {
        method: "GET",
        url: url,
        headers: {
          authorization: "Bearer " + this.$auth.getAccessToken(),
        },
        data: {},
      };
      return this.$http(req);
    }
  }

  getApplication(applicationId) {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/" + applicationId + "/?format=json&conf=web";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  removeUserFromChannel(data) {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/channels/rmv-users-from-channel?format=json&conf=web";
    var req = {
      method: "POST",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: data,
    };
    return this.$http(req);
  }

  pause_channel_loading_func(ch) {
    var _this = this;
    console.log("pause_channel_loading_func");
    _this.pause_channel_loading = true;
    _this.channels_in_queue.push(ch);

    console.log("what are the channels in the queue...");
    console.dir(_this.channels_in_queue);
  }
}

Messagingv2Service.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout"];



// WEBPACK FOOTER //
// ./client/app/services/messagingv2.js